import * as $ from 'jquery';

export class InfoPage {
    init() {
        $('body').on('click','.info-page h2.question', function() {
            $(this).next().toggle();
            return false;
        });

        $('body').on('click','#bank-times-costs .bank-header', function() {
            $(this).next().toggle();

            if ($(this).find('.up').length > 0) {
                $(this).find('.up').removeClass('up').addClass('down');
            } else {
                $(this).find('.down').removeClass('down').addClass('up');
            }

            return false;
        });
    }
}
